import './styles.scss';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {IStore} from '../../redux/interface';
import {Link, useParams} from 'react-router-dom';
import {useGetTranslations} from '../../utils/hooks/useGetTranslations';
import {TranslationKeys} from '../../utils/constants/routeConstants';
import {
  articleAsyncActions, getTeiArticle, getTeiArticleAuthors, getTeiArticleReference, getTeiReferenceAuthors
} from '../../redux/pageAsyncActions';
import './styles.scss';
import {closeArticleAuthors, closeArticleReference} from '../../redux/article/actions';
import Loader from '../../components/loader';
import {FormattedMessage} from 'react-intl';

export const ArticleAuthors: React.FunctionComponent = () => {
  const {
    article,
    reference,
    authors
  } = useSelector((state: IStore) => state.article);
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const dispatch = useDispatch();
  const {articleId, referenceId} = useParams();

  useGetTranslations({
    translationKey: TranslationKeys.Article
  });

  useEffect(() => {
    dispatch(closeArticleAuthors());
    if (referenceId && articleId) {
      if (!reference || (reference.id.toString()) !== referenceId) {
        dispatch(articleAsyncActions[getTeiArticleReference](articleId, referenceId));
      }
      dispatch(articleAsyncActions[getTeiReferenceAuthors](articleId, referenceId));
    } else if (articleId) {
      dispatch(closeArticleReference());
      if (!article || article.id.toString() !== articleId) {
        dispatch(articleAsyncActions[getTeiArticle](articleId));
      }
      dispatch(articleAsyncActions[getTeiArticleAuthors](articleId));
    }
  }, [articleId, referenceId]);

  return <div className="authors-page">
    {(loading.includes(getTeiArticleAuthors) || loading.includes(getTeiReferenceAuthors)) && <Loader className="authors-page__loader"/>}
    {<header className="authors-page__header">
      <h1><FormattedMessage
        id={'gritx.article.authors'}
        defaultMessage={'Authors'}
      /></h1>
      {article && <Link to={`/article/${article.id}`} className="authors-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to Article'}
        /></Link>}
      {reference && !article && <Link to={`/article/${reference.articleId}`} className="authors-page__link">
        <FormattedMessage
          id={'gritx.article.backToArticle'}
          defaultMessage={'Back to Article'}
        /></Link>}
      {reference && <Link to={`/article/references/${reference.articleId}`} className="authors-page__link">
        <FormattedMessage
          id={'gritx.article.backToReferences'}
          defaultMessage={'Back to References'}
        /></Link>}
      {reference && <Link to={`/article/reference/${reference.articleId}/${reference.id}`} className="authors-page__link">
        <FormattedMessage
          id={'gritx.article.backToReference'}
          defaultMessage={'Back to Reference'}
        /></Link>}
    </header>}

    {authors && <main className="authors-page__container">
      <div className="authors-page__body">
        {authors.map((a, i) => {
          return <div className="authors-page__body-line" key={i}>
            <div>{i + 1}. </div>
            <div className="authors-page__author-info">
              <span className="authors-page__full-name">{a.fullName}</span>
              {a.email && <span>
                <a className="authors-page__email" href={`mailto:${a.email}`}>{a.email}</a>
              </span>}
              {a.affiliation && <span className="authors-page__affiliation"><FormattedMessage
                id={'gritx.article.affiliation'}
                defaultMessage={'Affiliation'}
              />: {a.affiliation}</span>}
            </div>
          </div>;
        })}
      </div>
    </main>}
  </div>;
};
